import { Injectable, OnDestroy } from '@angular/core';
import { BlockingLoaderService } from '@salesrun/ngx-blocking-loader';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class TimeoutPauseService implements OnDestroy {
    private _destroy$ = new Subject<boolean>();
    private _pause$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    get pause$(): Observable<boolean> {
        return this._pause$.asObservable();
    }

    constructor(progress: BlockingLoaderService) {
        progress
            .visible$
            .pipe(takeUntil(this._destroy$))
            .subscribe(show => this.setPause(show));
    }

    setPause(value: boolean): void {
        this._pause$.next(value);
    }

    ngOnDestroy(): void {
        this._destroy$.next(true);
        this._destroy$.complete();
    }
}
